import { IconButton, Box } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import { useAuthWrapperContext } from 'Contexts/AuthWrapperContext';
import { SxProps } from '@mui/material';
import { TOUCH_TARGET_MIN_SIZE_PX } from 'Utils/touchTarget';

// The button's size with a mouse: 8px of padding around its 26px icon.
const LOG_OUT_BUTTON_SIZE_PX = 42;

const LogOutButton = (sx: SxProps) => {
  const auth = useAuthWrapperContext();

  return (
    <Box sx={{ ...sx }}>
      <IconButton
        aria-label="Log out"
        onClick={() => {
          auth?.logOut();
        }}
        // A full 44px target on a touch screen; the margin gives the extra back on every side, so
        // the layouts that hold it in their flow (the paywall's compact one) do not grow.
        sx={{
          '@media (pointer: coarse)': {
            minWidth: `${TOUCH_TARGET_MIN_SIZE_PX}px`,
            minHeight: `${TOUCH_TARGET_MIN_SIZE_PX}px`,
            margin: `${(LOG_OUT_BUTTON_SIZE_PX - TOUCH_TARGET_MIN_SIZE_PX) / 2}px`,
          },
        }}
      >
        <LogoutIcon
          sx={{
            color: 'rgb(255,255,255,0.8)',
            '&:hover': {
              color: 'rgb(255,255,255,1.0)',
            },
            fontSize: '26px',
            transform: 'scaleX(-1)',
          }}
        />
      </IconButton>
    </Box>
  );
};

export default LogOutButton;
